<template>
<div>
    <div class="form-row">
        <div class="col-8">
            <form-input label="Plan Name" v-model="formData.plan_name" :errors="errors.plan_name" type="text" :maxlength="128" />
        </div>

        <div class="col-4">
            <form-input label="Plan Type" v-model="formData.plan_type" :errors="errors.plan_type" type="select" :options="planTypeOptions" />
        </div>
    </div>

    <div class="form-row" v-if="showPlanNumber">
        <div class="col-8">
            <form-input label="Plan Number" v-model="formData.plan_number" :errors="errors.plan_number" type="text" :maxlength="48" />
        </div>
    </div>

    <h5>Eligibility Rules</h5>
    <div class="form-row">
        <div class="col-8">
            <form-input label="Min. Length of Service" v-model="formData.has_min_length_of_service" :errors="errors.has_min_length_of_service" type="checkbox" />
        </div>

        <div class="col-4">
            <form-input label="Min. Length of Service (years)" v-model="formData.min_length_of_service" :errors="errors.min_length_of_service" type="integer-string" :disabled="!formData.has_min_length_of_service" />
        </div>
    </div>

    <div class="form-row">
        <div class="col-8">
            <form-input label="Min. Age" v-model="formData.has_min_age" :errors="errors.has_min_age" type="checkbox" />
        </div>

        <div class="col-4">
            <form-input label="Min. Age (years)" v-model="formData.min_age" :errors="errors.min_age" type="integer-string" :disabled="!formData.has_min_age" />
        </div>
    </div>

    <div class="form-row">
        <div class="col-8">
            <form-input label="Min. Hours" v-model="formData.has_min_hours" :errors="errors.has_min_hours" type="checkbox" />
        </div>

        <div class="col-4">
            <form-input label="Min. Hours" v-model="formData.min_hours" :errors="errors.min_hours" type="integer-string" :disabled="!formData.has_min_hours" />
        </div>
    </div>

    <div class="form-row">
        <div class="col">
            <form-input label="Money Manager" v-model="formData.money_manager" :errors="errors.money_manager" type="select" :options="moneyManagerOptions" />
        </div>
    </div>

    <p v-if="formData.money_manager == 'paymasters'">
        Deposit funds to:
    </p>

    <div class="form-row" v-if="formData.money_manager == 'paymasters'">
        <div class="col">
            <form-input
                label="ACH Routing Number"
                v-model="formData.routing_number"
                :errors="errors.routing_number"
                type="integer-string"
                maxlength="9"
                extraclasses=""
                @update:model-value="onUpdateRoutingNumber()"
                :helperHtml="bankNameHtml"
                :popoverHelperHtml="'<p>Your bank&rsquo;s Routing Number is the first set of numbers on the bottom of your check. It is 9 digits long.</p>'"
            />

        </div>

        <div class="col">
            <form-input
                label="Account Number"
                v-model="formData.account_number"
                :errors="errors.account_number"
                type="integer-string"
                maxlength="17"
                :popoverHelperHtml="'<p>Your Account Number is the second set of numbers on the bottom of your check. It can vary in length.</p>'"
            />

            <p v-if="formData.account_number_last_4"><small>Leave blank if you do not wish to update it.</small></p>
        </div>
    </div>

    <div class="form-row mb-2" v-if="formData.money_manager == 'paymasters'">
        <div class="col">
            <form-input label="Third Party Check" v-model="formData.third_party_check" :errors="errors.third_party_check" type="checkbox" />
        </div>
    </div>

    <div class="form-row mb-2">
        <div class="col">
            <form-input label="Employer offers a match" v-model="formData.has_employer_match" :errors="errors.has_employer_match" type="checkbox" />
        </div>
    </div>

    <div v-if="formData.has_employer_match" v-for="(matchTier, idx) in formData.match_tiers" :key="matchTier.id">
        <match-tier-form
            ref="matchTierForms"
            :model-value="matchTier"
            @update:model-value="formData.match_tiers[idx] = $evt"
            :employee-contribution-label="idx == 0 ? 'For the first (%)' : 'For the next (%)'"
            :show-remove="idx != 0"
            @remove="removeTier(idx)"
        />

        <p class="text-center">
            <a href class="btn btn-link" @click.prevent="addTier()">Add another tier</a>
        </p>
    </div>

    <form-errors :errors="formErrors" />
</div>
</template>

<script>
import FormMixin from '@/mixins/Form'
import MatchTierForm from './MatchTierForm'

export default {
    props: ['initialValue', 'showPlanNumber', ],
    mixins: [FormMixin, ],
    components: {MatchTierForm, },
    computed: {
        planTypeOptions() {
            return [
                {text: 'SIMPLE IRA', value: 'simple-ira'},
                {text: '401K', value: '401k'},
                {text: '403B', value: '403b'},
                {text: 'IRA (Post-Tax)', value: 'roth-ira'},
            ]
        },
        moneyManagerOptions() {
            return [
                {text: 'Paymasters', value: 'paymasters'},
                {text: 'Company', value: 'company'},
            ]
        },
        bankNameHtml() {
            if (!this.bankName) {
                return ''
            }

            return '<i class="fas fa-fw fa-check mr-hf text-primary" aria-hidden="true"></i> ' + this.bankName
        },
    },
    data() {
        return {
            tierId: 1,
            bankName: '',
            bankNames: {},
            formData: this.makeFormData(),
            formRules: {
                plan_name: {presence: {allowEmpty: false}, },
                plan_type: {presence: {allowEmpty: false}, },
                plan_number: this.showPlanNumber ? {presence: {allowEmpty: false}, } : null,
                money_manager: {presence: {allowEmpty: false}, },
            },
            formLabels: {
            },
        }
    },
    watch: {
        'formData.has_employer_match'(o, n) {
            if (!this.formData.has_employer_match) {
                this.formData.match_tiers = [{
                    employee_contribution: '',
                    employer_match: '',
                }]
            }
        },
        'formData.has_min_length_of_service'(o, n) {
            if (!this.formData.has_min_length_of_service) {
                this.formData.min_length_of_service = ''
            }
        },
        'formData.has_min_age'(o, n) {
            if (!this.formData.has_min_age) {
                this.formData.min_age = ''
            }
        },
        'formData.has_min_hours'(o, n) {
            if (!this.formData.has_min_hours) {
                this.formData.min_hours = ''
            }
        },
    },
    methods: {
        makeFormData() {
            const matchTiers = []
            this.initialValue.match_tiers.forEach(mt => {
                matchTiers.push({
                    employee_contribution: mt.employee_contribution,
                    employer_match: mt.employer_match,
                })
            })

            if (matchTiers.length < 1) {
                matchTiers.push({
                    employee_contribution: '',
                    employer_match: '',
                })
            }

            return {
                plan_type: this.initialValue.plan_type ? this.initialValue.plan_type : '',
                plan_name: this.initialValue.plan_name ? this.initialValue.plan_name : '',
                plan_number: this.initialValue.plan_number ? this.initialValue.plan_number : '',
                money_manager: this.initialValue.money_manager ? this.initialValue.money_manager : '',
                has_employer_match: this.initialValue.has_employer_match ? this.initialValue.has_employer_match : '',
                has_min_length_of_service: this.initialValue.has_min_length_of_service,
                has_min_age: this.initialValue.has_min_age,
                has_min_hours: this.initialValue.has_min_hours,
                min_length_of_service: ('' + this.initialValue.min_length_of_service) ? this.initialValue.min_length_of_service : '',
                min_age: ('' + this.initialValue.min_age) ? this.initialValue.min_age : '',
                min_hours: ('' + this.initialValue.min_hours) ? this.initialValue.min_hours : '',
                routing_number: this.initialValue.routing_number ? this.initialValue.routing_number : '',
                account_number: this.initialValue.account_number ? this.initialValue.account_number : '',
                account_number_last_4: this.initialValue.account_number_last_4 ? this.initialValue.account_number_last_4 : '',
                third_party_check: this.initialValue.third_party_check ? this.initialValue.third_party_check : '',

                match_tiers: matchTiers,
            }
        },
        setErrors(errors) {
            Object.assign(this.errors, errors)
        },
        addTier() {
            this.formData.match_tiers.push({
                id: this.tierId++,
                employee_contribution: '',
                employer_match: '',
            })
        },
        removeTier(idx) {
            this.formData.match_tiers = this.formData.match_tiers.filter((mt, i) => {
                return i != idx
            })
        },
        getFormRules() {
            const rules = JSON.parse(JSON.stringify(this.formRules))
            if (this.formData.has_min_length_of_service) {
                rules.min_length_of_service = {presence: {allowEmpty: false}, }
            }
            if (this.formData.has_min_age) {
                rules.min_age = {presence: {allowEmpty: false}, }
            }
            if (this.formData.has_min_hours) {
                rules.min_hours = {presence: {allowEmpty: false}, }
            }

            if (this.formData.money_manager == 'paymasters') {
                rules.routing_number = {presence: {allowEmpty: false}, }
                if (!this.showPlanNumber) {
                    rules.account_number = {presence: {allowEmpty: false}, }
                }
            }

            return rules
        },
        onUpdateRoutingNumber() {
            this.errors.routing_number = []

            const routingNumber = this.formData.routing_number
            if (!routingNumber) {
                this.bankName = ''
                return
            }

            // only ask the API to validate if it looks like a valid-looking number
            if (routingNumber.length != 9) {
                this.bankName = ''
                return
            }

            if (this.bankNames.hasOwnProperty(routingNumber)) {
                this.bankName = this.bankNames[routingNumber]
                return
            }

            this.$api.post('/validate/brn', {'routing_number': routingNumber}).then((resp) => {
                this.bankName = resp['bank_name']
                this.bankNames[routingNumber] = resp['bank_name']
            }).catch((errors) => {
                this.errors.routing_number = errors['routing_number']
                this.bankName = ''
            })
        },
        validate() {
            this.errors = {}
            this.formErrors = []
            const originalValidate = FormMixin.methods.validate.bind(this)
            let isValid = originalValidate()

            this.$refs.matchTierForms.forEach(mtf => {
                isValid = mtf.validate() && isValid
            })

            if (!this.bankName) {
                isValid = false
                this.errors.routing_number = ['Routing number not found.']
            }

            return isValid
        },
        getFormData() {
            const data = JSON.parse(JSON.stringify(this.formData))

            data.match_tiers = []
            this.$refs.matchTierForms.forEach(mtf => {
                data.match_tiers.push(mtf.getFormData())
            })

            return data
        },
    },
}

</script>

